import { fetchApi } from "../../api/apiBase";

export const countriesServiceFactory = () => {
    const getCountries = () => fetchApi(`/countries?_limit=-1`);

    return { getCountries };
};
